import type { PropsWithChildren, ReactNode } from "react";
import clsx from "clsx";

type DetailsListItemProps = {
  title: ReactNode;
  value: ReactNode;
};

export function DetailsListItem({ title, value }: DetailsListItemProps) {
  return (
    <div>
      <dt className="mb-1 text-text-disabled-primary">{title}</dt>
      <dd className="font-medium">{value}</dd>
    </div>
  );
}

type Props = PropsWithChildren<{
  className?: string;
}>;

export function DetailsList({ className, children }: Props) {
  return (
    <dl className={clsx("grid grid-cols-2 gap-3 text-sm", className)}>
      {children}
    </dl>
  );
}
